export default __webpack_public_path__ + "static/media/aforemovil.53e9b6af.png";